import type { ReactElement } from 'react';
import type Crumb from './Crumb';
import type { CrumbProps } from './Crumb';

export type BreadcrumbChild<T> = ReactElement<CrumbProps<T>, typeof Crumb>;

export const classes = {
  link: 'hover:underline',
};
